var map = {
	"./apk.png": [
		55356,
		55356
	],
	"./appStore.png": [
		67676,
		67676
	],
	"./arrow_right.webp": [
		44508,
		44508
	],
	"./back.jpg": [
		59925,
		59925
	],
	"./bemFoundation.webp": [
		4069,
		4069
	],
	"./bemLogo.png": [
		3515,
		3515
	],
	"./blackLogo.png": [
		38874,
		38874
	],
	"./blogs/bcn.jpg": [
		53701,
		53701
	],
	"./blogs/benefits/cta1.jpg": [
		20992,
		20992
	],
	"./blogs/benefits/cta2.jpg": [
		34607,
		34607
	],
	"./blogs/benefits/cta3.jpg": [
		66674,
		66674
	],
	"./blogs/crowdfunding.webp": [
		6136,
		6136
	],
	"./blogs/goals.jpg": [
		23016,
		23016
	],
	"./blogs/header.jpg": [
		51845,
		51845
	],
	"./blogs/icons_dark/debt.svg": [
		29645,
		29645
	],
	"./blogs/icons_dark/equity.svg": [
		70419,
		70419
	],
	"./blogs/icons_dark/financialAssistance.svg": [
		15215,
		15215
	],
	"./blogs/icons_dark/reward.svg": [
		96435,
		96435
	],
	"./blogs/icons_light/debt.svg": [
		36591,
		36591
	],
	"./blogs/icons_light/equity.svg": [
		37833,
		37833
	],
	"./blogs/icons_light/financialAssistance.svg": [
		29173,
		29173
	],
	"./blogs/icons_light/reward.svg": [
		72653,
		72653
	],
	"./blogs/logos/bcn.png": [
		10568,
		10568
	],
	"./blogs/logos/bem.png": [
		75445,
		75445
	],
	"./blogs/logos/bemchain.png": [
		10846,
		10846
	],
	"./blogs/logos/bemex.png": [
		43694,
		43694
	],
	"./blogs/logos/bemgames.png": [
		90240,
		90240
	],
	"./blogs/logos/bemib.png": [
		48848,
		48848
	],
	"./blogs/logos/bempay.png": [
		78343,
		78343
	],
	"./blogs/logos/bempire.png": [
		54731,
		54731
	],
	"./blogs/logos/bemulator.png": [
		7842,
		7842
	],
	"./blogs/logos/tim.png": [
		79643,
		79643
	],
	"./blogs/marketmaker.jpg": [
		74208,
		74208
	],
	"./blogs/mmpworld.jpg": [
		5368,
		5368
	],
	"./blogs/risks.jpg": [
		57768,
		57768
	],
	"./bonus/blackFriday.jpg": [
		58786,
		58786
	],
	"./bonus/xmas.jpg": [
		90513,
		90513
	],
	"./cards/back.webp": [
		82863,
		82863
	],
	"./cards/black.webp": [
		41943,
		41943
	],
	"./cards/blue.webp": [
		264,
		264
	],
	"./cards/elite.webp": [
		47631,
		47631
	],
	"./cards/exclusive.webp": [
		30140,
		30140
	],
	"./cards/executive.webp": [
		75110,
		75110
	],
	"./cards/growth.webp": [
		90139,
		90139
	],
	"./cards/mmi.webp": [
		18389,
		18389
	],
	"./cards/mmi_white.webp": [
		15247,
		15247
	],
	"./cards/premier.webp": [
		49056,
		49056
	],
	"./cards/purple.webp": [
		23618,
		23618
	],
	"./cards/purple_planner.webp": [
		76165,
		76165
	],
	"./cards/red.webp": [
		32323,
		32323
	],
	"./cards/royal.webp": [
		56751,
		56751
	],
	"./cards/smart.webp": [
		89961,
		89961
	],
	"./cards/start.webp": [
		53512,
		53512
	],
	"./cards/white.webp": [
		85053,
		85053
	],
	"./cards/white_back.webp": [
		9205,
		9205
	],
	"./contract/p1.png": [
		31046,
		31046
	],
	"./contract/p10.png": [
		84084,
		84084
	],
	"./contract/p11.png": [
		5213,
		5213
	],
	"./contract/p12.png": [
		80326,
		80326
	],
	"./contract/p13.png": [
		2991,
		2991
	],
	"./contract/p14.png": [
		76496,
		76496
	],
	"./contract/p15.png": [
		73401,
		73401
	],
	"./contract/p2.png": [
		12253,
		12253
	],
	"./contract/p3.png": [
		79220,
		79220
	],
	"./contract/p4.png": [
		51512,
		29131
	],
	"./contract/p5.png": [
		8002,
		8002
	],
	"./contract/p6.png": [
		64089,
		64089
	],
	"./contract/p7.png": [
		57840,
		57840
	],
	"./contract/p8.png": [
		77751,
		77751
	],
	"./contract/p9.png": [
		32174,
		32174
	],
	"./contract/submit.png": [
		6519,
		6519
	],
	"./contract/true.png": [
		79351,
		79351
	],
	"./dashboard.webp": [
		29576,
		29576
	],
	"./dashboard_dark.webp": [
		8265,
		8265
	],
	"./diamonds/black.webp": [
		69601,
		69601
	],
	"./diamonds/blue.webp": [
		65750,
		65750
	],
	"./diamonds/elite.webp": [
		63981,
		63981
	],
	"./diamonds/exclusive.webp": [
		87214,
		87214
	],
	"./diamonds/executive.webp": [
		9084,
		9084
	],
	"./diamonds/growth.webp": [
		18677,
		18677
	],
	"./diamonds/mmi_false.webp": [
		11175,
		11175
	],
	"./diamonds/mmi_true.webp": [
		31404,
		31404
	],
	"./diamonds/premier.webp": [
		74662,
		74662
	],
	"./diamonds/purple.webp": [
		77896,
		77896
	],
	"./diamonds/purple_planner.webp": [
		34283,
		34283
	],
	"./diamonds/red.webp": [
		76821,
		76821
	],
	"./diamonds/royal.webp": [
		7941,
		7941
	],
	"./diamonds/smart.webp": [
		61135,
		61135
	],
	"./diamonds/start.webp": [
		69198,
		69198
	],
	"./diamonds/white.webp": [
		36831,
		36831
	],
	"./dot_dark.png": [
		2428,
		2428
	],
	"./dot_light.png": [
		47382,
		47382
	],
	"./false.png": [
		11971,
		11971
	],
	"./festival/EidToEid/bg.jpg": [
		36180,
		36180
	],
	"./festival/EidToEid/dates.svg": [
		23308,
		23308
	],
	"./festival/EidToEid/text.svg": [
		32676,
		32676
	],
	"./festival/anniversary.svg": [
		91771,
		91771
	],
	"./festival/appreciation/date.svg": [
		5145,
		5145
	],
	"./festival/appreciation/logo.svg": [
		29760,
		29760
	],
	"./festival/bg.jpg": [
		60548,
		60548
	],
	"./festival/bg.webp": [
		86054,
		86054
	],
	"./festival/blackFriday/bg.webp": [
		32355,
		32355
	],
	"./festival/blackFriday/date.svg": [
		99872,
		99872
	],
	"./festival/blackFriday/description.svg": [
		10250,
		10250
	],
	"./festival/blackFriday/logo.svg": [
		31065,
		31065
	],
	"./festival/blackFriday/logo.webp": [
		31431,
		31431
	],
	"./festival/boosterSpeed/bg.webp": [
		72720,
		72720
	],
	"./festival/boosterSpeed/date.svg": [
		35157,
		35157
	],
	"./festival/boosterSpeed/logo.webp": [
		66440,
		66440
	],
	"./festival/dates.png": [
		81154,
		81154
	],
	"./festival/dates.svg": [
		39922,
		39922
	],
	"./festival/gala/bg.jpg": [
		28644,
		28644
	],
	"./festival/gala/bgMob.jpg": [
		9748,
		9748
	],
	"./festival/gala/dates.svg": [
		90484,
		90484
	],
	"./festival/gala/extended.png": [
		13890,
		13890
	],
	"./festival/gala/img.png": [
		79380,
		79380
	],
	"./festival/gala/imgMob.png": [
		67804,
		67804
	],
	"./festival/gala/timeline.svg": [
		97792,
		97792
	],
	"./festival/gala/title.png": [
		56803,
		56803
	],
	"./festival/goldenFuture/date.webp": [
		93356,
		93356
	],
	"./festival/goldenFuture/date2.webp": [
		31966,
		31966
	],
	"./festival/goldenFuture/logo.webp": [
		26055,
		26055
	],
	"./festival/goldenFuture/logoMob.webp": [
		95619,
		95619
	],
	"./festival/img.png": [
		2068,
		2068
	],
	"./festival/logo.png": [
		69184,
		69184
	],
	"./festival/newSeason/bgDesktop.webp": [
		40522,
		40522
	],
	"./festival/newSeason/bgMobile.webp": [
		39024,
		39024
	],
	"./festival/newSeason/date.svg": [
		52983,
		52983
	],
	"./festival/newSeason/logo.svg": [
		68018,
		68018
	],
	"./festival/newSeason/title.svg": [
		38375,
		38375
	],
	"./festival/newYear/date.svg": [
		32131,
		32131
	],
	"./festival/newYear/logo.webp": [
		44570,
		44570
	],
	"./festival/newYear/mobileLogo.webp": [
		74676,
		74676
	],
	"./festival/newYear/title.svg": [
		56307,
		56307
	],
	"./festival/newYear/webLogo.webp": [
		66398,
		66398
	],
	"./festival/ramadanToNowruz/date.webp": [
		74222,
		74222
	],
	"./festival/ramadanToNowruz/logo.webp": [
		32637,
		32637
	],
	"./festival/spring404/dates.svg": [
		83822,
		83822
	],
	"./festival/spring404/logo.webp": [
		85622,
		85622
	],
	"./festival/title.svg": [
		83355,
		83355
	],
	"./festival/title.webp": [
		81825,
		81825
	],
	"./festival/xLogo.png": [
		60652,
		60652
	],
	"./flagship/1.svg": [
		91404,
		91404
	],
	"./flagship/2.svg": [
		46751,
		46751
	],
	"./flagship/3.svg": [
		41998,
		41998
	],
	"./flagship/bg.jpg": [
		524,
		524
	],
	"./flagship/cup.svg": [
		48653,
		48653
	],
	"./flagship/empire.svg": [
		17935,
		17935
	],
	"./flagship/logo.svg": [
		69286,
		69286
	],
	"./flagship/noAkhtaran.svg": [
		63942,
		63942
	],
	"./flagship/ticket.svg": [
		27695,
		27695
	],
	"./flagship/vsKit.png": [
		53322,
		53322
	],
	"./flagship/vsKitM.png": [
		59413,
		59413
	],
	"./goPro/bronze.svg": [
		23214,
		23214
	],
	"./goPro/gold.svg": [
		51388,
		51388
	],
	"./goPro/gp4Logo1.png": [
		3913,
		3913
	],
	"./goPro/gp4Logo2.png": [
		38770,
		38770
	],
	"./goPro/money.svg": [
		29610,
		29610
	],
	"./goPro/silver.svg": [
		54793,
		54793
	],
	"./goPro/ticket.svg": [
		2198,
		2198
	],
	"./goPro/top20.svg": [
		14689,
		14689
	],
	"./goPro/vipTicket.svg": [
		40427,
		40427
	],
	"./google.png": [
		1817,
		1817
	],
	"./gopro.jpg": [
		16069,
		16069
	],
	"./gopro3.png": [
		93530,
		93530
	],
	"./headers_dark/DEFIWallet.webp": [
		75887,
		75887
	],
	"./headers_dark/Genealogy.webp": [
		41621,
		41621
	],
	"./headers_dark/Max-cap.webp": [
		55579,
		55579
	],
	"./headers_dark/NFTWallet.webp": [
		25085,
		25085
	],
	"./headers_dark/activationHistory.webp": [
		28052,
		28052
	],
	"./headers_dark/activeInvestments.webp": [
		12896,
		12896
	],
	"./headers_dark/addendumRequest.webp": [
		2087,
		2087
	],
	"./headers_dark/bcninvestment.webp": [
		89762,
		89762
	],
	"./headers_dark/binaryOption.webp": [
		56104,
		56104
	],
	"./headers_dark/bonus.webp": [
		24891,
		24891
	],
	"./headers_dark/buyNFTRequest.webp": [
		21857,
		21857
	],
	"./headers_dark/buyTokenRequest.webp": [
		65010,
		65010
	],
	"./headers_dark/cardsList.webp": [
		31219,
		31219
	],
	"./headers_dark/changeLoginPassword.webp": [
		1380,
		1380
	],
	"./headers_dark/corporateSocialResponsibility.webp": [
		74350,
		74350
	],
	"./headers_dark/cryptoDeposit.webp": [
		9385,
		9385
	],
	"./headers_dark/cryptoDepositHistory.webp": [
		8535,
		8535
	],
	"./headers_dark/currentDepositHistory.webp": [
		32515,
		32515
	],
	"./headers_dark/customerSupport.webp": [
		22995,
		22995
	],
	"./headers_dark/debts.webp": [
		22730,
		22730
	],
	"./headers_dark/defiHistory.webp": [
		8794,
		8794
	],
	"./headers_dark/defiInvestment.webp": [
		54267,
		54267
	],
	"./headers_dark/depositsPortals.webp": [
		50290,
		50290
	],
	"./headers_dark/discountHistory.webp": [
		65949,
		65949
	],
	"./headers_dark/donate.webp": [
		51499,
		51499
	],
	"./headers_dark/downlines.webp": [
		5483,
		5483
	],
	"./headers_dark/downloadApp.webp": [
		74631,
		74631
	],
	"./headers_dark/downloadMT4.webp": [
		21931,
		21931
	],
	"./headers_dark/earlyTermination.webp": [
		79619,
		79619
	],
	"./headers_dark/flagshipBattle.webp": [
		84002,
		84002
	],
	"./headers_dark/foreignExchange.webp": [
		30861,
		30861
	],
	"./headers_dark/forexHistory.webp": [
		88242,
		88242
	],
	"./headers_dark/forexWallet.webp": [
		55351,
		55351
	],
	"./headers_dark/goPro1.webp": [
		91872,
		91872
	],
	"./headers_dark/goPro2.webp": [
		65581,
		65581
	],
	"./headers_dark/goPro3.webp": [
		10018,
		10018
	],
	"./headers_dark/goPro4.webp": [
		91455,
		91455
	],
	"./headers_dark/goldenRewardWallet.webp": [
		92687,
		92687
	],
	"./headers_dark/googleAuthenticator.webp": [
		65558,
		65558
	],
	"./headers_dark/home.webp": [
		39547,
		39547
	],
	"./headers_dark/incomeHistory.webp": [
		69173,
		69173
	],
	"./headers_dark/installmentPayment.webp": [
		53855,
		53855
	],
	"./headers_dark/installmentsTable.webp": [
		26492,
		26492
	],
	"./headers_dark/insuranceContract.webp": [
		20982,
		20982
	],
	"./headers_dark/insuranceDashboard.webp": [
		63292,
		63292
	],
	"./headers_dark/insuranceTermination.webp": [
		57314,
		57314
	],
	"./headers_dark/internalExchange.webp": [
		59152,
		59152
	],
	"./headers_dark/internalTransfer.webp": [
		94610,
		94610
	],
	"./headers_dark/investmentDashboard.webp": [
		3431,
		3431
	],
	"./headers_dark/investmentHistory.webp": [
		86611,
		86611
	],
	"./headers_dark/investmentPackage.webp": [
		33735,
		33735
	],
	"./headers_dark/kyc.webp": [
		43905,
		43905
	],
	"./headers_dark/liquidityPool.webp": [
		31074,
		31074
	],
	"./headers_dark/luckySpin.webp": [
		17484,
		17484
	],
	"./headers_dark/mT4Wallet.webp": [
		39650,
		39650
	],
	"./headers_dark/masterCardApplication.webp": [
		75466,
		75466
	],
	"./headers_dark/maxCap.webp": [
		37438,
		37438
	],
	"./headers_dark/memberLoans.webp": [
		18485,
		18485
	],
	"./headers_dark/membersLoan.webp": [
		14705,
		14705
	],
	"./headers_dark/migrate.webp": [
		39541,
		39541
	],
	"./headers_dark/millionairesChallenge.webp": [
		26749,
		26749
	],
	"./headers_dark/mmb.webp": [
		71928,
		71928
	],
	"./headers_dark/mmc.webp": [
		57275,
		57275
	],
	"./headers_dark/mmf.webp": [
		50644,
		50644
	],
	"./headers_dark/mmi.webp": [
		65117,
		65117
	],
	"./headers_dark/mt4History.webp": [
		17465,
		17465
	],
	"./headers_dark/myPackages.webp": [
		44831,
		44831
	],
	"./headers_dark/networkView.webp": [
		55771,
		55771
	],
	"./headers_dark/news.webp": [
		61947,
		61947
	],
	"./headers_dark/nftHistory.webp": [
		19940,
		19940
	],
	"./headers_dark/packageUpgrade.webp": [
		2784,
		2784
	],
	"./headers_dark/personalDonate.webp": [
		54123,
		54123
	],
	"./headers_dark/plannerDashboard.webp": [
		8684,
		8684
	],
	"./headers_dark/privacyPolicy.webp": [
		81770,
		81770
	],
	"./headers_dark/profile.webp": [
		8285,
		8285
	],
	"./headers_dark/purchaseInsurance.webp": [
		83845,
		83845
	],
	"./headers_dark/purchasePackage.webp": [
		20009,
		20009
	],
	"./headers_dark/securityPassword.webp": [
		77559,
		77559
	],
	"./headers_dark/sellCurrentDeposit.webp": [
		42897,
		42897
	],
	"./headers_dark/sellHistory.webp": [
		21968,
		21968
	],
	"./headers_dark/sponsorGenealogy.webp": [
		29043,
		29043
	],
	"./headers_dark/stars.webp": [
		67353,
		67353
	],
	"./headers_dark/stockMarket.webp": [
		22230,
		22230
	],
	"./headers_dark/submitAccount.webp": [
		63467,
		63467
	],
	"./headers_dark/termsAndConditions.webp": [
		74846,
		74846
	],
	"./headers_dark/tokenHistory.webp": [
		48515,
		48515
	],
	"./headers_dark/tokenPurchases.webp": [
		32015,
		32015
	],
	"./headers_dark/tokenWallet.webp": [
		74592,
		74592
	],
	"./headers_dark/topupActivationWallet.webp": [
		12171,
		12171
	],
	"./headers_dark/topupUSDT.webp": [
		12878,
		12878
	],
	"./headers_dark/tournment.webp": [
		50804,
		50804
	],
	"./headers_dark/trackingInstallments.webp": [
		43937,
		43937
	],
	"./headers_dark/transferHistory.webp": [
		39045,
		39045
	],
	"./headers_dark/usdtHistory.webp": [
		2880,
		2880
	],
	"./headers_dark/userResource.webp": [
		97923,
		97923
	],
	"./headers_dark/videoMarketing.webp": [
		4785,
		4785
	],
	"./headers_dark/walletHistory.webp": [
		32291,
		32291
	],
	"./headers_dark/walletTransfer.webp": [
		93278,
		93278
	],
	"./headers_dark/withdrawal.webp": [
		62907,
		62907
	],
	"./headers_dark/withdrawalHistory.webp": [
		19385,
		19385
	],
	"./headers_dark/withdrawalRequest.webp": [
		420,
		420
	],
	"./headers_light/DEFIWallet.webp": [
		48581,
		48581
	],
	"./headers_light/Genealogy.webp": [
		33263,
		33263
	],
	"./headers_light/NFTWallet.webp": [
		72611,
		72611
	],
	"./headers_light/activationHistory.webp": [
		78058,
		78058
	],
	"./headers_light/activeInvestments.webp": [
		35550,
		35550
	],
	"./headers_light/addendumRequest.webp": [
		3021,
		3021
	],
	"./headers_light/bcninvestment.webp": [
		67208,
		67208
	],
	"./headers_light/binaryOption.webp": [
		47806,
		47806
	],
	"./headers_light/bonus.webp": [
		50069,
		50069
	],
	"./headers_light/buyNFTRequest.webp": [
		72671,
		72671
	],
	"./headers_light/buyTokenRequest.webp": [
		46012,
		46012
	],
	"./headers_light/cardsList.webp": [
		83197,
		83197
	],
	"./headers_light/changeLoginPassword.webp": [
		33578,
		33578
	],
	"./headers_light/corporateSocialResponsibility.webp": [
		6528,
		6528
	],
	"./headers_light/cryptoDeposit.webp": [
		64623,
		64623
	],
	"./headers_light/cryptoDepositHistory.webp": [
		43509,
		43509
	],
	"./headers_light/currentDepositHistory.webp": [
		67697,
		67697
	],
	"./headers_light/customerSupport.webp": [
		27817,
		27817
	],
	"./headers_light/debts.webp": [
		64228,
		64228
	],
	"./headers_light/defiHistory.webp": [
		12412,
		12412
	],
	"./headers_light/defiInvestment.webp": [
		54229,
		54229
	],
	"./headers_light/depositsPortals.webp": [
		9188,
		9188
	],
	"./headers_light/discountHistory.webp": [
		12603,
		12603
	],
	"./headers_light/donate.webp": [
		14921,
		14921
	],
	"./headers_light/downlines.webp": [
		92377,
		92377
	],
	"./headers_light/downloadApp.webp": [
		42441,
		42441
	],
	"./headers_light/downloadMT4.webp": [
		1261,
		1261
	],
	"./headers_light/earlyTermination.webp": [
		96549,
		96549
	],
	"./headers_light/flagshipBattle.webp": [
		21848,
		21848
	],
	"./headers_light/foreignExchange.webp": [
		96471,
		96471
	],
	"./headers_light/forexHistory.webp": [
		23976,
		23976
	],
	"./headers_light/forexWallet.webp": [
		1329,
		1329
	],
	"./headers_light/goPro1.webp": [
		53022,
		53022
	],
	"./headers_light/goPro2.webp": [
		41663,
		41663
	],
	"./headers_light/goPro3.webp": [
		51420,
		51420
	],
	"./headers_light/goPro4.webp": [
		93997,
		93997
	],
	"./headers_light/goldenRewardWallet.webp": [
		83705,
		83705
	],
	"./headers_light/googleAuthenticator.webp": [
		35160,
		35160
	],
	"./headers_light/home.webp": [
		34653,
		34653
	],
	"./headers_light/incomeHistory.webp": [
		32063,
		32063
	],
	"./headers_light/installmentPayment.webp": [
		12397,
		12397
	],
	"./headers_light/installmentsTable.webp": [
		83450,
		83450
	],
	"./headers_light/insuranceContract.webp": [
		64496,
		64496
	],
	"./headers_light/insuranceDashboard.webp": [
		58950,
		58950
	],
	"./headers_light/insuranceTermination.webp": [
		93060,
		93060
	],
	"./headers_light/internalExchange.webp": [
		78054,
		78054
	],
	"./headers_light/internalTransfer.webp": [
		67936,
		67936
	],
	"./headers_light/investmentDashboard.webp": [
		98417,
		98417
	],
	"./headers_light/investmentHistory.webp": [
		93305,
		93305
	],
	"./headers_light/investmentPackage.webp": [
		66901,
		66901
	],
	"./headers_light/kyc.webp": [
		58971,
		58971
	],
	"./headers_light/liquidityPool.webp": [
		62988,
		62988
	],
	"./headers_light/luckySpin.webp": [
		78462,
		78462
	],
	"./headers_light/mT4Wallet.webp": [
		31344,
		31344
	],
	"./headers_light/masterCardApplication.webp": [
		40416,
		40416
	],
	"./headers_light/maxCap.webp": [
		13360,
		13360
	],
	"./headers_light/membersLoan.webp": [
		42087,
		42087
	],
	"./headers_light/migrate.webp": [
		40231,
		40231
	],
	"./headers_light/millionairesChallenge.webp": [
		83891,
		83891
	],
	"./headers_light/mmb.webp": [
		85110,
		85110
	],
	"./headers_light/mmc.webp": [
		49841,
		49841
	],
	"./headers_light/mmf.webp": [
		73946,
		73946
	],
	"./headers_light/mt4History.webp": [
		61683,
		61683
	],
	"./headers_light/myPackages.webp": [
		64517,
		64517
	],
	"./headers_light/networkView.webp": [
		22921,
		22921
	],
	"./headers_light/news.webp": [
		75437,
		75437
	],
	"./headers_light/nftHistory.webp": [
		36462,
		36462
	],
	"./headers_light/packageUpgrade.webp": [
		91866,
		91866
	],
	"./headers_light/personalDonate.webp": [
		27369,
		27369
	],
	"./headers_light/plannerDashboard.webp": [
		28390,
		28390
	],
	"./headers_light/privacyPolicy.webp": [
		8120,
		8120
	],
	"./headers_light/profile.webp": [
		33723,
		33723
	],
	"./headers_light/purchaseInsurance.webp": [
		20887,
		20887
	],
	"./headers_light/purchasePackage.webp": [
		5475,
		5475
	],
	"./headers_light/raw.webp": [
		49944,
		49944
	],
	"./headers_light/securityPassword.webp": [
		29309,
		29309
	],
	"./headers_light/sellCurrentDeposit.webp": [
		28419,
		28419
	],
	"./headers_light/sellHistory.webp": [
		51066,
		51066
	],
	"./headers_light/sponsorGenealogy.webp": [
		89225,
		89225
	],
	"./headers_light/stars.webp": [
		72031,
		72031
	],
	"./headers_light/stockMarket.webp": [
		36816,
		36816
	],
	"./headers_light/submitAccount.webp": [
		20117,
		20117
	],
	"./headers_light/termsAndConditions.webp": [
		86400,
		86400
	],
	"./headers_light/tokenHistory.webp": [
		13713,
		13713
	],
	"./headers_light/tokenPurchases.webp": [
		82185,
		82185
	],
	"./headers_light/tokenWallet.webp": [
		16426,
		16426
	],
	"./headers_light/topupActivationWallet.webp": [
		68853,
		68853
	],
	"./headers_light/topupUSDT.webp": [
		46040,
		46040
	],
	"./headers_light/trackingInstallments.webp": [
		72715,
		72715
	],
	"./headers_light/transferHistory.webp": [
		69903,
		69903
	],
	"./headers_light/usdtHistory.webp": [
		35450,
		35450
	],
	"./headers_light/userResource.webp": [
		27749,
		27749
	],
	"./headers_light/videoMarketing.webp": [
		94215,
		94215
	],
	"./headers_light/walletHistory.webp": [
		62517,
		62517
	],
	"./headers_light/walletTransfer.webp": [
		18932,
		18932
	],
	"./headers_light/withdrawal.webp": [
		70309,
		70309
	],
	"./headers_light/withdrawalHistory.webp": [
		52523,
		52523
	],
	"./headers_light/withdrawalRequest.webp": [
		28938,
		28938
	],
	"./home/bg.jpg": [
		31031,
		31031
	],
	"./home/crowdfunding.png": [
		17424,
		17424
	],
	"./home/hero_dark/1.webp": [
		27029,
		27029
	],
	"./home/hero_dark/2.webp": [
		10920,
		10920
	],
	"./home/hero_dark/3.webp": [
		24651,
		24651
	],
	"./home/hero_light/1.webp": [
		13871,
		13871
	],
	"./home/hero_light/2.webp": [
		37230,
		37230
	],
	"./home/hero_light/3.webp": [
		33257,
		33257
	],
	"./home/icons_dark/features.svg": [
		41393,
		41393
	],
	"./home/icons_dark/powerfull.svg": [
		12564,
		12564
	],
	"./home/icons_dark/safe.svg": [
		87899,
		87899
	],
	"./home/icons_dark/speed.svg": [
		78317,
		78317
	],
	"./home/icons_light/features.svg": [
		29851,
		29851
	],
	"./home/icons_light/powerfull.svg": [
		17502,
		17502
	],
	"./home/icons_light/safe.svg": [
		7041,
		7041
	],
	"./home/icons_light/speed.svg": [
		60579,
		60579
	],
	"./home/map_dark.png": [
		11331,
		11331
	],
	"./home/map_light.png": [
		1755,
		1755
	],
	"./home/marketmaker.png": [
		52004,
		52004
	],
	"./home/mmi.png": [
		54831,
		54831
	],
	"./home/mmp/1.jpg": [
		66510,
		66510
	],
	"./home/mmp/2.jpg": [
		81529,
		81529
	],
	"./home/mmp/3.jpg": [
		37180,
		37180
	],
	"./home/mmp/4.jpg": [
		91591,
		91591
	],
	"./home/permissions/1.jpg": [
		5336,
		5336
	],
	"./home/permissions/2.png": [
		89015,
		89015
	],
	"./home/permissions/3.jpg": [
		45258,
		45258
	],
	"./home/risks.jpg": [
		81320,
		81320
	],
	"./home/shadow.png": [
		61778,
		61778
	],
	"./home/superMarketingPlan.png": [
		34832,
		34832
	],
	"./home/superMarketingPlan.webp": [
		33190,
		33190
	],
	"./icon3d.png": [
		44382,
		44382
	],
	"./icons/accepted.svg": [
		9082,
		9082
	],
	"./icons/bemchain.png": [
		65794,
		65794
	],
	"./icons/cmc.png": [
		97154,
		97154
	],
	"./icons/coins/bcn.png": [
		50847,
		50847
	],
	"./icons/coins/tim.png": [
		37528,
		37528
	],
	"./icons/coins/trx.png": [
		13048,
		13048
	],
	"./icons/coins/usdt.png": [
		52520,
		52520
	],
	"./icons/crown.svg": [
		81346,
		81346
	],
	"./icons/crown_black.svg": [
		23118,
		23118
	],
	"./icons/failed.svg": [
		77170,
		77170
	],
	"./icons/forbidden.svg": [
		30520,
		30520
	],
	"./icons/identity.svg": [
		8063,
		8063
	],
	"./icons/info.svg": [
		87853,
		87853
	],
	"./icons/kyc.svg": [
		39384,
		39384
	],
	"./icons/menu_dark/activation.webp": [
		83562,
		83562
	],
	"./icons/menu_dark/activeLeftUsers.webp": [
		19735,
		19735
	],
	"./icons/menu_dark/activeRightUsers.webp": [
		35094,
		35094
	],
	"./icons/menu_dark/binaryOption.webp": [
		90190,
		90190
	],
	"./icons/menu_dark/bonus.webp": [
		30501,
		30501
	],
	"./icons/menu_dark/cryptoDeposit.webp": [
		45855,
		45855
	],
	"./icons/menu_dark/currentDeposit.webp": [
		60083,
		60083
	],
	"./icons/menu_dark/customerSupport.webp": [
		37369,
		37369
	],
	"./icons/menu_dark/dailyBalance.webp": [
		87141,
		87141
	],
	"./icons/menu_dark/dailyLeftInvestment.webp": [
		16447,
		16447
	],
	"./icons/menu_dark/dailyRightInvestment.webp": [
		39178,
		39178
	],
	"./icons/menu_dark/debts.webp": [
		69044,
		69044
	],
	"./icons/menu_dark/defi.webp": [
		64500,
		64500
	],
	"./icons/menu_dark/defiWallet.webp": [
		36533,
		36533
	],
	"./icons/menu_dark/depositsPortals.webp": [
		37044,
		37044
	],
	"./icons/menu_dark/discount.webp": [
		44229,
		44229
	],
	"./icons/menu_dark/donate.webp": [
		20281,
		20281
	],
	"./icons/menu_dark/downloadApp.webp": [
		76793,
		76793
	],
	"./icons/menu_dark/earlyTermination.webp": [
		8949,
		8949
	],
	"./icons/menu_dark/exit.webp": [
		55970,
		55970
	],
	"./icons/menu_dark/foreignExchange.webp": [
		90823,
		90823
	],
	"./icons/menu_dark/forex.webp": [
		26328,
		26328
	],
	"./icons/menu_dark/forexWallet.webp": [
		7489,
		7489
	],
	"./icons/menu_dark/genealogy.webp": [
		83263,
		83263
	],
	"./icons/menu_dark/home.webp": [
		2765,
		2765
	],
	"./icons/menu_dark/incomeHistory.webp": [
		73967,
		73967
	],
	"./icons/menu_dark/internalExchange.webp": [
		1942,
		1942
	],
	"./icons/menu_dark/investmentDashboard.webp": [
		66177,
		66177
	],
	"./icons/menu_dark/luckySpin.webp": [
		84718,
		84718
	],
	"./icons/menu_dark/masterCardApplication.webp": [
		29648,
		29648
	],
	"./icons/menu_dark/maxCap.webp": [
		60640,
		60640
	],
	"./icons/menu_dark/membersLoan.webp": [
		53655,
		53655
	],
	"./icons/menu_dark/mmb.webp": [
		89606,
		89606
	],
	"./icons/menu_dark/mmc.webp": [
		81281,
		81281
	],
	"./icons/menu_dark/mmf.webp": [
		14858,
		14858
	],
	"./icons/menu_dark/mmi.webp": [
		50495,
		50495
	],
	"./icons/menu_dark/myProfile.webp": [
		91649,
		91649
	],
	"./icons/menu_dark/news.webp": [
		9117,
		9117
	],
	"./icons/menu_dark/nft.webp": [
		82838,
		82838
	],
	"./icons/menu_dark/nftWallet.webp": [
		18963,
		18963
	],
	"./icons/menu_dark/noData.webp": [
		77049,
		77049
	],
	"./icons/menu_dark/packages.webp": [
		49855,
		49855
	],
	"./icons/menu_dark/plannerDashboard.webp": [
		89078,
		89078
	],
	"./icons/menu_dark/privacyPolicy.webp": [
		96840,
		96840
	],
	"./icons/menu_dark/stockMarket.webp": [
		62592,
		62592
	],
	"./icons/menu_dark/termsAndConditions.webp": [
		61040,
		61040
	],
	"./icons/menu_dark/token.webp": [
		34771,
		34771
	],
	"./icons/menu_dark/tokenWallet.webp": [
		16762,
		16762
	],
	"./icons/menu_dark/totalLeftInvestment.webp": [
		79216,
		79216
	],
	"./icons/menu_dark/totalRightInvestment.webp": [
		59015,
		59015
	],
	"./icons/menu_dark/usdt.webp": [
		36602,
		36602
	],
	"./icons/menu_dark/userResource.webp": [
		13941,
		13941
	],
	"./icons/menu_dark/videoMarketing.webp": [
		98263,
		98263
	],
	"./icons/menu_dark/walletHistory.webp": [
		71237,
		71237
	],
	"./icons/menu_dark/walletTransfer.webp": [
		84740,
		84740
	],
	"./icons/menu_dark/walletWithdrawal.webp": [
		69904,
		69904
	],
	"./icons/menu_light/activation.webp": [
		78080,
		78080
	],
	"./icons/menu_light/activeLeftUsers.webp": [
		8969,
		8969
	],
	"./icons/menu_light/activeRightUsers.webp": [
		42744,
		42744
	],
	"./icons/menu_light/binaryOption.webp": [
		57564,
		57564
	],
	"./icons/menu_light/bonus.webp": [
		90023,
		90023
	],
	"./icons/menu_light/cryptoDeposit.webp": [
		71821,
		71821
	],
	"./icons/menu_light/currentDeposit.webp": [
		20553,
		20553
	],
	"./icons/menu_light/customerSupport.webp": [
		69463,
		69463
	],
	"./icons/menu_light/dailyBalance.webp": [
		92047,
		92047
	],
	"./icons/menu_light/dailyLeftInvestment.webp": [
		92165,
		92165
	],
	"./icons/menu_light/dailyRightInvestment.webp": [
		10888,
		10888
	],
	"./icons/menu_light/debts.webp": [
		45238,
		45238
	],
	"./icons/menu_light/defi.webp": [
		73486,
		73486
	],
	"./icons/menu_light/defiWallet.webp": [
		43371,
		43371
	],
	"./icons/menu_light/depositsPortals.webp": [
		19390,
		19390
	],
	"./icons/menu_light/discount.webp": [
		95867,
		95867
	],
	"./icons/menu_light/donate.webp": [
		22847,
		22847
	],
	"./icons/menu_light/downloadApp.webp": [
		70163,
		70163
	],
	"./icons/menu_light/earlyTermination.webp": [
		45319,
		45319
	],
	"./icons/menu_light/exit.webp": [
		76824,
		76824
	],
	"./icons/menu_light/foreignExchange.webp": [
		40041,
		40041
	],
	"./icons/menu_light/forex.webp": [
		88062,
		88062
	],
	"./icons/menu_light/forexWallet.webp": [
		84859,
		84859
	],
	"./icons/menu_light/genealogy.webp": [
		96065,
		96065
	],
	"./icons/menu_light/home.webp": [
		79503,
		79503
	],
	"./icons/menu_light/incomeHistory.webp": [
		54937,
		54937
	],
	"./icons/menu_light/internalExchange.webp": [
		93668,
		93668
	],
	"./icons/menu_light/investmentDashboard.webp": [
		55731,
		55731
	],
	"./icons/menu_light/luckySpin.webp": [
		39272,
		39272
	],
	"./icons/menu_light/masterCardApplication.webp": [
		75502,
		75502
	],
	"./icons/menu_light/maxCap.webp": [
		14322,
		14322
	],
	"./icons/menu_light/membersLoan.webp": [
		10285,
		10285
	],
	"./icons/menu_light/mmb.webp": [
		44588,
		44588
	],
	"./icons/menu_light/mmc.webp": [
		18031,
		18031
	],
	"./icons/menu_light/mmf.webp": [
		87760,
		87760
	],
	"./icons/menu_light/mmi.webp": [
		96945,
		96945
	],
	"./icons/menu_light/myProfile.webp": [
		73911,
		73911
	],
	"./icons/menu_light/news.webp": [
		40751,
		40751
	],
	"./icons/menu_light/nft.webp": [
		13240,
		13240
	],
	"./icons/menu_light/nftWallet.webp": [
		80257,
		80257
	],
	"./icons/menu_light/noData.webp": [
		8071,
		8071
	],
	"./icons/menu_light/packages.webp": [
		91413,
		91413
	],
	"./icons/menu_light/plannerDashboard.webp": [
		39920,
		39920
	],
	"./icons/menu_light/privacyPolicy.webp": [
		78694,
		78694
	],
	"./icons/menu_light/stockMarket.webp": [
		56402,
		56402
	],
	"./icons/menu_light/termsAndConditions.webp": [
		59522,
		59522
	],
	"./icons/menu_light/token.webp": [
		87025,
		87025
	],
	"./icons/menu_light/tokenWallet.webp": [
		11324,
		11324
	],
	"./icons/menu_light/totalLeftInvestment.webp": [
		86994,
		86994
	],
	"./icons/menu_light/totalRightInvestment.webp": [
		3761,
		3761
	],
	"./icons/menu_light/usdt.webp": [
		86884,
		86884
	],
	"./icons/menu_light/userResource.webp": [
		9311,
		9311
	],
	"./icons/menu_light/videoMarketing.webp": [
		22693,
		22693
	],
	"./icons/menu_light/walletHistory.webp": [
		7695,
		7695
	],
	"./icons/menu_light/walletTransfer.webp": [
		84706,
		84706
	],
	"./icons/menu_light/walletWithdrawal.webp": [
		12454,
		12454
	],
	"./icons/mmp.png": [
		97467,
		97467
	],
	"./icons/noData_dark.webp": [
		59693,
		59693
	],
	"./icons/noData_light.webp": [
		69587,
		69587
	],
	"./icons/pass.svg": [
		22746,
		22746
	],
	"./icons/pending.svg": [
		75158,
		75158
	],
	"./icons/person.svg": [
		50610,
		50610
	],
	"./icons/rejected.svg": [
		923,
		923
	],
	"./icons/sponsor_dark/balance.webp": [
		48831,
		48831
	],
	"./icons/sponsor_dark/dailyLeft.webp": [
		31711,
		31711
	],
	"./icons/sponsor_dark/dailyRight.webp": [
		45168,
		45168
	],
	"./icons/sponsor_dark/leftUsers.webp": [
		62532,
		62532
	],
	"./icons/sponsor_dark/rightUsers.webp": [
		48359,
		48359
	],
	"./icons/sponsor_dark/totalLeft.webp": [
		32684,
		32684
	],
	"./icons/sponsor_dark/totalRight.webp": [
		63629,
		63629
	],
	"./icons/sponsor_light/balance.webp": [
		91343,
		91343
	],
	"./icons/sponsor_light/dailyLeft.webp": [
		82447,
		82447
	],
	"./icons/sponsor_light/dailyRight.webp": [
		45184,
		45184
	],
	"./icons/sponsor_light/leftUsers.webp": [
		25908,
		25908
	],
	"./icons/sponsor_light/rightUsers.webp": [
		44791,
		44791
	],
	"./icons/sponsor_light/totalLeft.webp": [
		93212,
		93212
	],
	"./icons/sponsor_light/totalRight.webp": [
		76285,
		76285
	],
	"./icons/star.svg": [
		5125,
		5125
	],
	"./icons/submit.svg": [
		30889,
		30889
	],
	"./icons/success.svg": [
		75970,
		75970
	],
	"./icons/ticket.svg": [
		31793,
		31793
	],
	"./icons/usd.svg": [
		32967,
		32967
	],
	"./icons/user.svg": [
		42360,
		42360
	],
	"./icons/warn.svg": [
		20601,
		20601
	],
	"./kyc/Selfie/Sfalse1.jpg": [
		11294,
		11294
	],
	"./kyc/Selfie/Sfalse2.jpg": [
		2793,
		2793
	],
	"./kyc/Selfie/Sfalse3.jpg": [
		5004,
		5004
	],
	"./kyc/Selfie/Sfalse4.jpg": [
		65239,
		65239
	],
	"./kyc/Selfie/selfieCorrect.jpg": [
		23345,
		23345
	],
	"./kyc/idBack/0.jpg": [
		76077,
		76077
	],
	"./kyc/idBack/1.jpg": [
		32624,
		32624
	],
	"./kyc/idBack/2.jpg": [
		63935,
		63935
	],
	"./kyc/idBack/3.jpg": [
		27586,
		27586
	],
	"./kyc/idBack/4.jpg": [
		40497,
		40497
	],
	"./kyc/idBack/5.jpg": [
		61972,
		61972
	],
	"./kyc/idBack/6.jpg": [
		63779,
		63779
	],
	"./kyc/idFront/0.jpg": [
		31233,
		31233
	],
	"./kyc/idFront/1.jpg": [
		53188,
		53188
	],
	"./kyc/idFront/2.jpg": [
		53235,
		53235
	],
	"./kyc/idFront/3.jpg": [
		81622,
		81622
	],
	"./kyc/idFront/4.jpg": [
		38493,
		38493
	],
	"./kyc/idFront/5.jpg": [
		12928,
		12928
	],
	"./kyc/idFront/6.jpg": [
		95919,
		95919
	],
	"./kyc/passport/0.jpg": [
		3241,
		3241
	],
	"./kyc/passport/1.jpg": [
		47980,
		47980
	],
	"./kyc/passport/2.jpg": [
		8603,
		8603
	],
	"./kyc/passport/3.jpg": [
		23646,
		23646
	],
	"./kyc/passport/4.jpg": [
		70981,
		70981
	],
	"./kyc/passport/5.jpg": [
		27016,
		27016
	],
	"./kyc/passport/6.jpg": [
		37943,
		37943
	],
	"./loginBack.webp": [
		21994,
		21994
	],
	"./loginBackBF.webp": [
		43066,
		43066
	],
	"./loginBack_dark.webp": [
		40907,
		40907
	],
	"./logo.png": [
		62077,
		62077
	],
	"./logo/bem_dark.png": [
		6905,
		6905
	],
	"./logo/bem_light.png": [
		24185,
		24185
	],
	"./logo/dark.webp": [
		25448,
		25448
	],
	"./logo/icon_dark.webp": [
		52710,
		52710
	],
	"./logo/icon_light.webp": [
		2622,
		2622
	],
	"./logo/light.webp": [
		9376,
		9376
	],
	"./logo512.png": [
		4981,
		4981
	],
	"./logoMMI.svg": [
		28272,
		28272
	],
	"./logo_2025.png": [
		50243,
		50243
	],
	"./logo_2D.png": [
		45368,
		45368
	],
	"./logo_fall.webp": [
		34017,
		34017
	],
	"./logo_org.png": [
		3914,
		3914
	],
	"./logo_x.png": [
		30548,
		30548
	],
	"./midyear.svg": [
		31029,
		31029
	],
	"./migrateImg.png": [
		34148,
		34148
	],
	"./millionaires/bg.webp": [
		27210,
		27210
	],
	"./millionaires/club.webp": [
		85433,
		85433
	],
	"./millionaires/clubRanks/1.svg": [
		80900,
		80900
	],
	"./millionaires/clubRanks/10.svg": [
		61052,
		61052
	],
	"./millionaires/clubRanks/2.svg": [
		24023,
		24023
	],
	"./millionaires/clubRanks/3.svg": [
		9638,
		9638
	],
	"./millionaires/clubRanks/4.svg": [
		39081,
		39081
	],
	"./millionaires/clubRanks/5.svg": [
		34840,
		34840
	],
	"./millionaires/clubRanks/6.svg": [
		85579,
		85579
	],
	"./millionaires/clubRanks/7.svg": [
		70970,
		70970
	],
	"./millionaires/clubRanks/8.svg": [
		57645,
		57645
	],
	"./millionaires/clubRanks/9.svg": [
		58700,
		58700
	],
	"./millionaires/gift.webp": [
		87263,
		87263
	],
	"./millionaires/globalRanks/1.svg": [
		57791,
		57791
	],
	"./millionaires/globalRanks/10.svg": [
		74205,
		74205
	],
	"./millionaires/globalRanks/2.svg": [
		78764,
		78764
	],
	"./millionaires/globalRanks/3.svg": [
		26125,
		26125
	],
	"./millionaires/globalRanks/4.svg": [
		97602,
		97602
	],
	"./millionaires/globalRanks/5.svg": [
		1331,
		1331
	],
	"./millionaires/globalRanks/6.svg": [
		40320,
		40320
	],
	"./millionaires/globalRanks/7.svg": [
		54705,
		54705
	],
	"./millionaires/globalRanks/8.svg": [
		87174,
		87174
	],
	"./millionaires/globalRanks/9.svg": [
		92503,
		92503
	],
	"./millionaires/logo.webp": [
		14174,
		14174
	],
	"./millionaires/lottery.webp": [
		94266,
		94266
	],
	"./millionaires/point1.svg": [
		23524,
		23524
	],
	"./millionaires/point2.svg": [
		94327,
		94327
	],
	"./millionaires/ticket.svg": [
		21411,
		21411
	],
	"./plannerDashboardAsset.zip": [
		68387,
		68387
	],
	"./ranks/rank_0.svg": [
		42987,
		42987
	],
	"./ranks/rank_1.svg": [
		65466,
		65466
	],
	"./ranks/rank_10.svg": [
		97158,
		97158
	],
	"./ranks/rank_11.svg": [
		2487,
		2487
	],
	"./ranks/rank_12.svg": [
		48036,
		48036
	],
	"./ranks/rank_13.svg": [
		45285,
		45285
	],
	"./ranks/rank_14.svg": [
		21754,
		21754
	],
	"./ranks/rank_2.svg": [
		10281,
		10281
	],
	"./ranks/rank_3.svg": [
		84920,
		84920
	],
	"./ranks/rank_4.svg": [
		29847,
		29847
	],
	"./ranks/rank_5.svg": [
		40870,
		40870
	],
	"./ranks/rank_6.svg": [
		72645,
		72645
	],
	"./ranks/rank_7.svg": [
		75396,
		75396
	],
	"./ranks/rank_8.svg": [
		38675,
		38675
	],
	"./ranks/rank_9.svg": [
		34946,
		34946
	],
	"./raw.jpg": [
		95884,
		95884
	],
	"./sectionBack.webp": [
		89196,
		89196
	],
	"./stars/1.svg": [
		60819,
		60819
	],
	"./stars/2.svg": [
		40064,
		40064
	],
	"./stars/3.svg": [
		76017,
		76017
	],
	"./stars/desktop.svg": [
		74654,
		74654
	],
	"./stars/empire.svg": [
		54718,
		54718
	],
	"./stars/frameDesktop.webp": [
		60529,
		60529
	],
	"./stars/frameMobile.webp": [
		97965,
		97965
	],
	"./stars/mainLogo.svg": [
		63788,
		63788
	],
	"./stars/mobile.svg": [
		20996,
		20996
	],
	"./stars/noAkhtaran.svg": [
		27519,
		27519
	],
	"./stars/ticket.svg": [
		71138,
		71138
	],
	"./stars/twinLarge.svg": [
		5777,
		5777
	],
	"./stars/twinSmall.svg": [
		44457,
		44457
	],
	"./success.png": [
		53475,
		53475
	],
	"./tokens/bcn.svg": [
		63562,
		63562
	],
	"./tokens/bems.svg": [
		3418,
		3418
	],
	"./tokens/bsm.svg": [
		31689,
		31689
	],
	"./tokens/tim.svg": [
		79621,
		79621
	],
	"./true.png": [
		4212,
		4212
	],
	"./userClass/investor.svg": [
		53978,
		53978
	],
	"./userClass/none.svg": [
		23300,
		23300
	],
	"./userClass/planner.svg": [
		27286,
		27286
	],
	"./userClass/white.svg": [
		50361,
		50361
	],
	"./utility_dark/404.webp": [
		24602,
		24602
	],
	"./utility_dark/access.webp": [
		65444,
		65444
	],
	"./utility_dark/comingSoon.webp": [
		50006,
		50006
	],
	"./utility_dark/error.webp": [
		46420,
		46420
	],
	"./utility_dark/underMaintenance.webp": [
		83123,
		83123
	],
	"./utility_light/404.png": [
		14762,
		14762
	],
	"./utility_light/404.webp": [
		26476,
		26476
	],
	"./utility_light/access.png": [
		24030,
		24030
	],
	"./utility_light/access.webp": [
		67746,
		67746
	],
	"./utility_light/comingSoon.png": [
		94824,
		94824
	],
	"./utility_light/comingSoon.webp": [
		57796,
		57796
	],
	"./utility_light/error.png": [
		10956,
		10956
	],
	"./utility_light/error.webp": [
		54750,
		54750
	],
	"./utility_light/underMaintenance.png": [
		76279,
		76279
	],
	"./utility_light/underMaintenance.webp": [
		33705,
		33705
	],
	"./verification/level_0.svg": [
		60527,
		60527
	],
	"./verification/level_1.svg": [
		75569,
		97950
	],
	"./verification/level_2.svg": [
		52125,
		52125
	],
	"./verification/level_3.svg": [
		97852,
		97852
	],
	"./verification/level_4.svg": [
		56131,
		56131
	],
	"./wallets/activation.jpg": [
		66545,
		66545
	],
	"./wallets/currentDeposit.jpg": [
		95006,
		95006
	],
	"./wallets/defi.jpg": [
		70495,
		70495
	],
	"./wallets/discount.jpg": [
		19860,
		19860
	],
	"./wallets/forex.jpg": [
		98019,
		98019
	],
	"./wallets/goldenReward.jpg": [
		18123,
		18123
	],
	"./wallets/icons/activation.svg": [
		95616,
		95616
	],
	"./wallets/icons/currentDeposit.svg": [
		33071,
		33071
	],
	"./wallets/icons/defi.svg": [
		49494,
		49494
	],
	"./wallets/icons/discount.svg": [
		41753,
		41753
	],
	"./wallets/icons/forex.svg": [
		58382,
		58382
	],
	"./wallets/icons/nft.svg": [
		77840,
		77840
	],
	"./wallets/icons/token.svg": [
		64175,
		64175
	],
	"./wallets/icons/usdt.svg": [
		21708,
		21708
	],
	"./wallets/nft.jpg": [
		7453,
		7453
	],
	"./wallets/token.jpg": [
		57006,
		57006
	],
	"./wallets/usdt.jpg": [
		79713,
		79713
	],
	"./warning.png": [
		46070,
		46070
	],
	"./warning.svg": [
		1004,
		1004
	],
	"./warning2.png": [
		21590,
		21590
	],
	"./xLogo.png": [
		8123,
		8123
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 85680;
module.exports = webpackAsyncContext;